// extracted by mini-css-extract-plugin
export var highlightFade = "_2b-4";
export var highlighted = "_2b-3";
export var table = "_2b-1";
export var tableContainer = "_2b-0";
export var totalsRow = "_2b-2";